import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import SearchOptionInterface from 'layouts/header/search/search-option.interface';
import './dropdown-menu.scss';

const DropdownMenu: React.FC<{
    options: SearchOptionInterface[];
    onSelect: (event: any) => void;
    value: string;
}> = props => (
    <Dropdown.Menu as="ul">
        {props.options.map(option => (
            <Dropdown.Item
                as="li"
                data-item={JSON.stringify(option)}
                onClick={props.onSelect}
                className={props.value === option.name ? 'is-selected' : ''}
                key={option.name}
            >
                {option.name}
            </Dropdown.Item>))}
    </Dropdown.Menu>
);

export default DropdownMenu;
